import ActiveWorkOrderIcon from '../../../shared/assets/icons/ActiveWorkOrderIcon';
import AwaitingPartsIcon from '../../../shared/assets/icons/AwaitingPartsIcon';
import CompletedIcon from '../../../shared/assets/icons/CompletedIcon';
import LeaderFourIcon from '../../../shared/assets/icons/LeaderFourIcon';
import LeaderOneIcon from '../../../shared/assets/icons/LeaderOneIcon';
import LeaderThreeIcon from '../../../shared/assets/icons/LeaderThreeIcon';
import LeaderTwoIcon from '../../../shared/assets/icons/LeaderTwoIcon';
import {SortOptions} from '@features/dashboard/components/WorkOrders/WorkOrderProps';
import RequestedParts from '@shared/assets/icons/RequestedParts';
import IssuedParts from '@shared/assets/icons/IssuedParts';
import DelayedParts from '@shared/assets/icons/DelayedParts';
import Typography from '@shared/constants/Typography';
import RepairsIcon from '@shared/assets/icons/RepairsIcon';
import PartsInventoryIcon from '@shared/assets/icons/PartsInventory';
import { Platform } from 'react-native';

// Leader Board constants
export const leaderBoardListData = [
  {
    id: 1,
    name: 'Marcus Johnson',
    repairs: 47,
  },
  {
    id: 2,
    name: 'Sarah Chen',
    repairs: 42,
  },
  {
    id: 3,
    name: 'James Rodriguez',
    repairs: 38,
  },
  {
    id: 4,
    name: 'John Martinez',
    repairs: 49,
  },
];

export const leaderBoardColors = {
  1: {
    bgColor: 'LeaderOneColorBG',
    border: 'LeaderOneColorBorder',
    icon: LeaderOneIcon,
  },
  2: {
    bgColor: 'LeaderTwoColorBG',
    border: 'LeaderTwoColorBorder',
    icon: LeaderTwoIcon,
  },
  3: {
    bgColor: 'LeaderThreeColorBG',
    border: 'LeaderThreeColorBorder',
    icon: LeaderThreeIcon,
  },
  4: {
    bgColor: 'LeaderRemainingColorBG',
    border: 'LeaderRemainingColorBorder',
    icon: LeaderFourIcon,
    iconBg: 'LeaderFourIconBG',
    iconBorderColor: 'LeaderFourIconBorder',
  },
  5: {
    bgColor: 'LeaderRemainingColorBG',
    border: 'LeaderRemainingColorBorder',
    icon: LeaderFourIcon,
  },
};

// Score Board constants
export const scoreBoardData = [
  {
    title: 'dashboard.scoreBoard.activeWorkOrders',
    key: 'Active',
    icon: ActiveWorkOrderIcon,
  },
  {
    title: 'dashboard.scoreBoard.awaitingParts',
    key: 'Awaiting Parts',
    icon: AwaitingPartsIcon,
  },
  {
    title: 'dashboard.scoreBoard.completedWorkOrders',
    key: 'Completed',
    icon: CompletedIcon,
  },
];

// Score Board constants
export const repairBoardData = [
  {
    title: 'dashboard.parts.kpiCards.requested',
    key: 'requested',
    icon: RequestedParts,
  },
  {
    title: 'dashboard.parts.kpiCards.onOrder',
    key: 'onOrder',
    icon: IssuedParts,
  },
  {
    title: 'dashboard.parts.kpiCards.reserved',
    key: 'reserved',
    icon: DelayedParts,
  },
];

// Scrore chart constants
export const scoreChartData = [
  {
    title: 'dashboard.statusChart.active',
    key: 'Active',
    color: 'statusActive',
  },
  {
    title: 'dashboard.statusChart.inProgress',
    key: 'Assigned',
    color: 'statusInprogress',
  },
  {
    title: 'dashboard.statusChart.completed',
    key: 'Completed',
    color: 'statusCompleted',
  },
];

// Work orders constants
export const workOrderTabsConst = {
  all: 'All',
  active: 'Active',
  assigned: 'Assigned',
  completed: 'Complete',
  awaitingParts: 'Awaiting Parts',
  open: 'Open',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  requestedParts: 'Requested',
  issuedParts: 'Issued',
  delayedParts: 'Delayed',
  repairs: 'Repairs',
  partsInventory: 'Parts Inventory',
  previousWO: 'Previous WorkOrders',
  activeRequest: 'Active Requests',
  pastRequests: 'Past Requests',
  working: 'Working',
  pending: 'Pending',
  closed: 'Closed'
};

export const workOrderTabs = [
  {
    text: 'dashboard.workOrders.tabs.all',
    value: workOrderTabsConst.all,
  },
  {
    // text: 'dashboard.workOrders.tabs.open',
    text: 'dashboard.workOrders.tabs.openTab',
    value: workOrderTabsConst.open,
  },
  {
    // text: 'dashboard.workOrders.tabs.closed',
    text: 'dashboard.workOrders.tabs.completedTab',
    value: workOrderTabsConst.completed,
  },
  // {
  //   // text: 'dashboard.workOrders.tabs.previousWO',
  //   text: 'dashboard.workOrders.tabs.previousWOTab',
  //   value: workOrderTabsConst.previousWO,
  // },
];

export const partsTabs = [
  // {
  //   text: 'dashboard.workOrders.partsTab.all',
  //   value: workOrderTabsConst.all,
  // },
  {
    text: 'dashboard.workOrders.partsTab.activeRequest',
    value: workOrderTabsConst.activeRequest,
  },
  // {
  //   text: 'dashboard.workOrders.partsTab.pastRequests',
  //   value: workOrderTabsConst.pastRequests,
  // },
];

export const dashboardTabs = [
  {
    text: 'dashboard.tabs.repairs',
    value: workOrderTabsConst.repairs,
    icon: RepairsIcon,
  },
  {
    text: 'dashboard.tabs.partsInventory',
    value: workOrderTabsConst.partsInventory,
    icon: PartsInventoryIcon,
  },
];

export const sortOptions: SortOptions[] = [
  {label: 'dashboard.workOrders.sortOptions.all', value: ''},
  {label: 'dashboard.workOrders.sortOptions.urgent', value: 'RED'},
  {label: 'dashboard.workOrders.sortOptions.high', value: 'UR'},
  {label: 'dashboard.workOrders.sortOptions.medium', value: 'ASAP'},
  {label: 'dashboard.workOrders.sortOptions.low', value: 'WP'},
];

export const partsSortOptions: SortOptions[] = [
  {label: 'Requested', value: 'requested'},
  {label: 'Delayed', value: 'delayed'},
  {label: 'Issued', value: 'issued'},
];

export const repairSortOptions: SortOptions[] = [
  {label: 'dashboard.workOrders.assetNumber', value: 'asset number'},
  {label: 'dashboard.workOrders.licenseNumber', value: 'license'},
  {label: 'dashboard.workOrders.workOrderId', value: 'document id'},
  // {label: 'dashboard.workOrders.repairId', value: 'repair id'},
  {label: 'dashboard.workOrders.vinCode', value: 'serial number'},
];

// Validation type mapping for search filters
export const validationTypeMapping: Record<
  string,
  'alphabets' | 'numbers' | 'alphanumeric'
> = {
  'asset number': 'alphanumeric',
  license: 'alphanumeric',
  'document id': 'numbers',
  'repair id': 'numbers',
  'serial number': 'alphanumeric',
};

export const validationLengthMapping: Record<string, number> = {
  'asset number': 25,
  'document id': 10,
  'repair id': 10,
  license: 10,
  'serial number': 25,
};

export const repairFilterOptions: SortOptions[] = [
  {
    label: 'dashboard.workOrders.repairFilterOptions.myRepairsInMyShop',
    value: '0',
  },
  {
    label: 'dashboard.workOrders.repairFilterOptions.myRepairsInAllShops',
    value: '1',
  },
  {
    label: 'dashboard.workOrders.repairFilterOptions.allRepairsInMyShop',
    value: '2',
  },
  {
    label: 'dashboard.workOrders.repairFilterOptions.allRepairsInAllShops',
    value: '3',
  },
];

export const workOrderStatus = {
  inProgress: 'In Progress',
  notStarted: 'Not Started',
  working: 'Working',
  open: 'Open',
};

export const partsColumns = [
  {
    key: 'status',
    sortKey: 'requestPartStatus',
    label: 'dashboard.workOrders.partsGrids.status',
    flex: 3,
    width: Typography.width.width145 + Typography.width.width160,
  },
  {
    key: 'partName',
    sortKey: 'partName',
    label: 'dashboard.workOrders.partsGrids.partsName',
    flex: 3,
    width: Typography.width.width300 + Typography.width.width200,
  },
  {
    key: 'partDesc',
    label: 'dashboard.workOrders.partsGrids.partsDesc',
    flex: 3,
    width: Typography.width.width300 + Typography.width.width200,
  },
  {
    key: 'requestComment',
    label: 'dashboard.workOrders.partsGrids.requestComment',
    flex: 3,
    width: Typography.width.width300 + Typography.width.width200,
  },
  {
    key: 'partId',
    sortKey: 'partID',
    label: 'dashboard.workOrders.partsGrids.partId',
    flex: 3,
    width: Typography.width.width360,
  },
  {
    key: 'repairId',
    sortKey: 'repairID',
    label: 'dashboard.workOrders.partsGrids.repairCode',
    flex: 3,
    width: Typography.width.width360,
  },
  {
    key: 'woId',
    sortKey: 'documentID',
    label: 'dashboard.workOrders.partsGrids.WoNumber',
    flex: 1,
    width: Typography.width.width360,
  },
];

export const columns = [
  {
    key: 'priorityDesc',
    label: 'dashboard.workOrders.grids.priority',
    flex: 1,
    width: Typography.width.width160 + Typography.width.width60,
  },
  {
    key: 'hasParts',
    label: 'dashboard.workOrders.grids.partsInList',
    flex: 1,
    width: Typography.width.width160 + Typography.width.width80,
    //itemCenterAlign: true,
  },
  {
    key: 'assetNumber',
    label: 'dashboard.workOrders.grids.vehicleName',
    flex: 3,
    width: Typography.width.width252,
  },
  {
    key: 'yearMakeModel',
    label: 'dashboard.workOrders.grids.yearMakeModel',
    flex: 3,
    width: Typography.width.width252,
  },
  {
    key: 'documentId',
    label: 'dashboard.workOrders.grids.woNumber',
    flex: 3,
    width: Typography.width.width198,
  },
  {
    key: 'workOrderStatusDesc',
    label: 'dashboard.workOrders.grids.woStatus',
    flex: 3,
    width: Typography.width.width145,
  },
  {
    key: 'repairId',
    label: 'dashboard.workOrders.grids.repairCode',
    flex: 3,
    width: Typography.width.width184,
  },
  {
    key: 'actionDesc',
    label: 'dashboard.workOrders.grids.repairDesc',
    flex: 3,
    width: Typography.width.width273,
  },
  {
    key: 'maintShopDesc',
    label: 'dashboard.workOrders.grids.shop',
    flex: 1,
    width: Typography.width.width160,
  },
  {
    key: 'timeStandardHours',
    label: 'dashboard.workOrders.grids.timeStandard',
    flex: 1,
    width: Typography.width.width213,
  },
  {
    key: 'inDate',
    label: 'dashboard.workOrders.grids.dateIn',
    flex: 1,
    width: Typography.width.width190,
  },
  {
    key: 'notificationCount',
    label: 'dashboard.workOrders.grids.message',
    flex: 1,
    width: Typography.width.width232,
    itemCenterAlign: true,
  },
  {
    key: 'authorizationstring',
    label: 'dashboard.workOrders.woSpendingAuthorization',
    flex: 1,
    width: Typography.width.width232,
    itemCenterAlign: true,
  },
  {
    key: 'actions',
    label: 'dashboard.workOrders.grids.actions',
    flex: 1,
    width:
      Platform.OS === 'web'
        ? Typography.width.width300
        : Typography.width.width300,
    //itemCenterAlign: true,
  },

  // {
  //   key: 'status',
  //   label: 'dashboard.workOrders.grids.status',
  //   flex: 1.2,
  //   width: Typography.width.width130,
  // },
  // {
  //   key: 'dueDate',
  //   label: 'dashboard.workOrders.grids.dueDate',
  //   flex: 1.8,
  //   width: Typography.width.width138,
  //   alignRight: true,
  // },
];

export const badges = {
  High: {
    color: 'highPriorityTextColor',
    bgColor: 'highPriorityBGColor',
    borderColor: 'highPriorityBorderColor',
  },
  Medium: {
    color: 'mediumPriorityTextColor',
    bgColor: 'mediumPriorityBGColor',
    borderColor: 'mediumPriorityBorderColor',
  },
  Low: {
    color: 'lowPriorityTextColor',
    bgColor: 'lowPriorityBGColor',
    borderColor: 'lowPriorityBorderColor',
  },
  Open: {
    color: 'assignedColor',
    bgColor: 'assignedBG',
    borderColor: 'assignedColorBorder',
  },
  Completed: {
    color: 'completedColor',
    bgColor: 'completedBG',
    borderColor: 'completedColorBorder',
  },
  'Awaiting Parts': {
    color: 'activeColor',
    bgColor: 'activeBG',
    borderColor: 'activeColorBorder',
  },
  Active: {
    color: 'activeColor',
    bgColor: 'activeBG',
    borderColor: 'activeColorBorder',
  },
  Assigned: {
    color: 'assignedColor',
    bgColor: 'assignedBG',
    borderColor: 'assignedColorBorder',
  },
  'Off Shift': {
    color: 'technicianStatusTextOffline',
    bgColor: 'technicianStatusBGOffline',
    borderColor: 'transparent',
  },
  'On Shift': {
    bgColor: 'technicianStatusBGOnline',
    color: 'technicianStatusTextOnline',
    borderColor: 'transparent',
  },
  Requested: {
    color: 'assignedColor',
    bgColor: 'assignedBG',
    borderColor: 'assignedColorBorder',
  },
  Delayed: {
    color: 'lowPriorityTextColor',
    bgColor: 'lowPriorityBGColor',
    borderColor: 'lowPriorityBorderColor',
  },
  Issued: {
    color: 'completedColor',
    bgColor: 'completedBG',
    borderColor: 'completedColorBorder',
  },
};

export const sam = {
  repairId: 774,
  repairScheduleID: '2',
  assetId: 4411,
  assetNumber: '1111',
  assetThumbnail:
    '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',
  yearMake: '2009 Ford',
  model: 'Explorer',
  actionDesc: 'PressToRelease',
  groupDesc: 'Ram Compaction',
  componentDesc: 'System',
  technicianId: 3,
  technicianName: 'Local Admin',
  documentId: 664,
  documentNumber: '',
  maintShopId: 1,
  maintShop: '001',
  priority: '',
  priorityDesc: '',
  inDate: '2010-01-28T17:21:29.04',
  promiseDate: null,
  repairStatus: '',
  status: '',
  woSpendingAuthorized: null,
  license: null,
  serialNumber: null,
};

export const shiftDetails = [
  {
    key: 'duration',
    value: 'dashboard.shiftSection.shiftDurationTitle',
  },
  {
    key: 'repairsCompleted',
    value: 'dashboard.shiftSection.repairsCompleted',
  },
];

export const repairsDetails = [
  {
    key: 'duration',
    value: 'dashboard.shiftSection.shiftDurationTitle',
  },
];

export const endRepairsDetails = [
  {
    key: 'duration',
    value: 'dashboard.repairSection.repairDurationTitle',
  },
];

export const repairsPriorities = {
  normal: 'Medium',
  critical: 'High',
  emergency: 'Urgent',
  low: 'Low',
};
